export default __webpack_public_path__ + "static/ak-cached/24h/media/Fire-Cube.3a64ffef.jpeg";